export class Store<T> {
    public data:Array<T>= new Array<T>();
    public version:number=0;
    public isNewInstance():boolean{
        return this.data.length===0 && this.version===0;
    }
}